import { ErrorToast, PlusIcon } from '@vgrubs/components';
import Compressor from 'compressorjs';
import { MouseEventHandler, useRef } from 'react';
import styled from 'styled-components';

const BrandImageInputStyled = styled.div<{
  disabled: boolean;
}>`
  width: 130px;
  height: 130px;
  cursor: pointer;
  position: relative;
  margin-bottom: 40px;
  ${({ disabled }) => disabled && 'cursor: not-allowed;'}
  background-color: ${({ theme }) => theme.white};
  border: 2px solid ${({ theme }) => theme.primary};
  border-radius: 50%;

  > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 130px;
    height: 130px;
    border-radius: 50%;
    overflow: hidden;

    > img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }

    > div {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  input {
    visibility: hidden;
    height: 0;
    width: 0;
  }
`;

export const BrandImageInput = ({
  image,
  onChange,
  disabled,
}: {
  image: string | File | Blob | null;
  onChange: (img: File | Blob) => void;
  disabled: boolean;
}) => {
  const imageUrl =
    typeof image === 'string' ? image : image && URL.createObjectURL(image);

  const inputFileRef = useRef<HTMLInputElement>(null);

  const onBtnClick: MouseEventHandler<HTMLDivElement> = () => {
    inputFileRef.current?.click();
  };

  const handleChange = (e) => {
    const files = e.target.files;
    const file = files[0];
    const maxSize = 2097152;


    if (files.length) {
      new Compressor(file, {
        quality: 0.8,
        maxWidth: 2500,
        maxHeight: 1500,
        convertSize: 2097152,
        success: (compressedResult) => {
          if (compressedResult.size > maxSize) {
            return ErrorToast('Image file too big');
          } else {
            onChange(compressedResult);
          }
        },
      });
    }
  };

  return (
    <BrandImageInputStyled
      onClick={!disabled ? onBtnClick : undefined}
      disabled={disabled}
    >
      <input ref={inputFileRef} type="file" onChange={handleChange} />

      <div>
        {image ? (
          <img src={imageUrl || undefined} alt="add brand" />
        ) : (
          <div>
            <PlusIcon />
          </div>
        )}
      </div>
    </BrandImageInputStyled>
  );
};
